module.exports = __webpack_public_path__ + "img/nineone.0e9714c4.png";